export const blogCardData = [
  {
    date: "13 April 2021",
    description:
      "Creative stealth pitch. Client entrepreneur gamification firstmover advantage social proof",
  },
  {
    date: "12 April 2021",
    description:
      "Creative stealth pitch. Client entrepreneur gamification firstmover advantage social proof",
  },
  {
    date: "11 April 2021",
    description:
      "Creative stealth pitch. Client entrepreneur gamification firstmover advantage social proof",
  },
  {
    date: "10 April 2021",
    description:
      "Creative stealth pitch. Client entrepreneur gamification firstmover advantage social proof",
  },
  {
    date: "9 April 2021",
    description:
      "Creative stealth pitch. Client entrepreneur gamification firstmover advantage social proof",
  },
  {
    date: "8 April 2021",
    description:
      "Creative stealth pitch. Client entrepreneur gamification firstmover advantage social proof",
  },
  {
    date: "7 April 2021",
    description:
      "Creative stealth pitch. Client entrepreneur gamification firstmover advantage social proof",
  },
  {
    date: "6 April 2021",
    description:
      "Creative stealth pitch. Client entrepreneur gamification firstmover advantage social proof",
  },
  {
    date: "5 April 2021",
    description:
      "Creative stealth pitch. Client entrepreneur gamification firstmover advantage social proof",
  },
  {
    date: "4 April 2021",
    description:
      "Creative stealth pitch. Client entrepreneur gamification firstmover advantage social proof",
  },
];

export const blogCategoryData = [
  {
    date: "13 April 2021",
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit ut",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Duis id et egestas cursus.",
  },
  {
    date: "12 April 2021",
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit ut",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Duis id et egestas cursus.",
  },
  {
    date: "11 April 2021",
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit ut",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Duis id et egestas cursus.",
  },
  {
    date: "10 April 2021",
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit ut",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Duis id et egestas cursus.",
  },
  {
    date: "9 April 2021",
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit ut",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Duis id et egestas cursus.",
  },
  {
    date: "8 April 2021",
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit ut",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Duis id et egestas cursus.",
  },
  {
    date: "7 April 2021",
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit ut",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Duis id et egestas cursus.",
  },
  {
    date: "6 April 2021",
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit ut",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Duis id et egestas cursus.",
  },
  {
    date: "5 April 2021",
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit ut",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Duis id et egestas cursus.",
  },
  {
    date: "4 April 2021",
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit ut",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Duis id et egestas cursus.",
  },
];
